export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10436.fa5125eb.jpg";